import TeamTable from '../TeamTable';

const Distance90 = () => { 
  return <TeamTable  distance={"90"} targetType={"PRE"}/>;
};
export default Distance90;
